import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedAdminRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user")); // stored on login

  // Case 1: No token at all → not logged in
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Case 2: Logged in but not admin → redirect to dashboard
  if (!user || user.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }

  // Case 3: Admin access granted
  return children;
};

export default ProtectedAdminRoute;
